class HeaderSearch extends HTMLElement {
  wrapper;
  button;
  openButton;
  input;

  constructor() {
    super();
    this.wrapper = this.querySelector('.form');
    this.input = this.querySelector('input[name="q"]');
    this.button = this.querySelector('button[type=submit]');
    this.openButton = this.querySelector('.toggle-header-search');

    this.openButton.addEventListener('click', (ev) => {
      this.showForm();
    });

    if (this.dataset.hasOwnProperty('searchPage')) {
      this.initSearchPageBehaviour();
    }

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('q')) {
      this.input.value = searchParams.get('q');
      this.showForm();
      this.expand();
      this.input.classList.add('md:w-96');
    }

    this.input.addEventListener('focus', (ev) => {
      this.expand();
    });

    this.input.addEventListener('blur', (ev) => {
      if (this.input.value === '') {
        this.contract();
        if (ev.relatedTarget === this.button) {
          this.input.closest('li').nextElementSibling.querySelector('a, button')?.focus();
        }
      } else {
        this.input.classList.add('md:w-96');
      }
    });
  }

  showForm() {
    this.querySelector('.mask').classList.add('hidden');
    this.querySelector('.form').classList.remove('hidden');
    this.input.focus();
  }

  hideForm() {
    this.querySelector('.mask').classList.remove('hidden');
    this.querySelector('.form').classList.add('hidden');
  }

  expand() {
    this.button.removeAttribute('disabled');
    this.button.classList.add('opacity-100');
    this.button.classList.remove('pointer-events-none');
    this.input.classList.remove('md:w-96');
    this.wrapper.classList.add('lg:after:bg-gray-600');
  }

  contract() {
    this.button.setAttribute('disabled', 'disabled');
    this.button.classList.remove('opacity-100');
    this.button.classList.add('pointer-events-none');
    this.wrapper.classList.remove('lg:after:bg-gray-600');
    waitForTransitionEnd(this).then(() => this.hideForm());
  }

  initSearchPageBehaviour() {
    const mediaQueryList = window.matchMedia('(max-width: 1023px)');
    const parentNode = this.parentElement;
    function handleViewportChange(mql) {
      if (mql.matches) {
        let templateSearch = document.querySelector('.template-search');
        if (templateSearch && templateSearch.querySelector('header-search')) {
          templateSearch.querySelector('header-search').replaceWith(this);
        } else if (templateSearch) {
          templateSearch.prepend(this);
        }
        console.log('matches');
      } else {
        if (!parentNode.contains(this)) {
          parentNode?.appendChild(this);
        }
        console.log('not matches');
      }
    }

    handleViewportChange.bind(this)(mediaQueryList);

    mediaQueryList.addEventListener('change', handleViewportChange.bind(this));
  }
}

customElements.define('header-search', HeaderSearch);
